module.exports = __webpack_public_path__ + "components/media-kit/static/article-desktop-e5ceb4298f7c5869c837c27057adb879.png";